export default {"src":"/_next/static/media/info_icon.209d44d1.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};